import React from 'react';
import 'antd/dist/antd.less';
import './ant-table.css';
import { Translate, withLocalize } from 'react-localize-redux';
import './communityCatalog.css';
import { CommunityCatalogImage } from './CommunityCatalogImage';
import { connectToUserPreferences } from '../UserPreferences';

class CommunityCatalogsTableRow extends React.Component {
	render() {
		const baseUrl = process.env.REACT_APP_API_URL;

		return (
			<div className="column pad-5">
				<div className="column-spaced community-catalog-image-column">
					<div className="column community-catalog-image-container">
						{this.props.row.userProfilePicPath ? (
							<div className="community-catalog-image-profilepic">
								<img
									title={this.props.row.userName}
									alt={this.props.row.userName}
									src={this.props.row.userProfilePicPath}
								/>
							</div>
						) : null}
						<CommunityCatalogImage
							imageUrl={this.props.row.catalogImagePath}
							catalogName={this.props.row.catalogName}
						/>
					</div>
				</div>
				<div className="column-spaced">
					<div className="text-medium">
						<a
							href={`${baseUrl}/#catalogID=${this.props.row.catalogId}&page=1`}
							className="community-catalog-name-link"
							style={{
								color: this.props.userPreferences.fonts
									.accFontOption,
							}}
							target="_parent">
							{this.props.row.catalogName}
						</a>
					</div>
					<div className="text-medium">
						<Translate id="updated" />: {this.props.row.userName}
					</div>
					<div className="text-medium">
						<Translate id="shared" />:{' '}
						{this.props.activeLanguage
							? this.props.row.sharedDate.toLocaleDateString(
									this.props.activeLanguage.code,
							  )
							: this.props.row.sharedDate.toLocaleDateString()}
					</div>
					<div className="text-medium">
						<Translate id="created" />:{' '}
						{this.props.activeLanguage
							? this.props.row.sharedDate.toLocaleDateString(
									this.props.activeLanguage.code,
							  )
							: this.props.row.updatedDate.toLocaleDateString()}
					</div>
				</div>
			</div>
		);
	}
}

export default connectToUserPreferences(CommunityCatalogsTableRow);
